import search from '../../../assets/img/search.svg'
import React, { Fragment, useCallback } from 'react'
import logo from '../../constants/mrf-logo'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import styles from './index.module.css'
import {actions} from '.././../redux-store/reducer'

import {
  Grid,
  Button,
  Link,
  Typography,
  Popover,
  ButtonBase,
} from '@material-ui/core'
import cn from 'classname'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'

export default ({ banner, location: { pathname } }) => {
  const dispatch = useDispatch();
  const isSignupPage = pathname.startsWith('/iscriviti');
  const headlineLines = banner && String(banner.titolo).trim().replace(/\s+/g, ' ').replace(/'/g, '’') === 'CAMBIARE L’ITALIA È POSSIBILE. FARLO INSIEME È UNA RESPONSABILITÀ.'
    ? ['CAMBIARE L’ITALIA È POSSIBILE.', 'FARLO INSIEME È UNA RESPONSABILITÀ.']
    : null;

  const isLogged = useSelector(state => state.user.isLogged)

  // STUFF DISABLED FOR NOW, LATER IMPLMEMENTED
  const disabled = true

  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = !!anchorEl

  const sections = [
    {
      label: 'primo piano',
      href: '/',
      isSelected: pathname === '/',
    },
    {
      label: 'video',
      href: '/lista/video/1/',
      isSelected: pathname.includes('/video'),
    },
    {
      label: 'sanità',
      href: '/sanita/1/',
      isSelected: pathname.includes('/sanita'),
    },
    {
      label: 'politica',
      href: '/politica/1/',
      isSelected:
        pathname.includes('/politica') ||
        pathname.includes('/lavoro') ||
        pathname.includes('/legalita') ||
        pathname.includes('/fiscalita') ||
        pathname.includes('/economia'),
      subMenu: [
        {
          label: 'lavoro',
          href: '/lavoro/1/',
        },
        {
          label: 'legalità',
          href: '/legalita/1/',
        },

        {
          label: 'fiscalità',
          href: '/fiscalita/1/',
        },
        {
          label: 'economia',
          href: '/economia/1/',
        },
      ],
    },
    /* disabled for now
    {
      label: 'cosa ne pensi',
      isSelected: pathname.includes('/cosa-pensi')
    }
     */
  ].sort((a, b) => a.label.localeCompare(b.label, 'it'))

  const handleShowLoginDialog = useCallback((() => {
    dispatch(actions.setShowLoginDialog(true));
  }), [])

  return (
    <div className={styles.header}>
      <div className={styles.headerInfo} style={{ height: 'auto', minHeight: '116px', padding: '8px 0' }}>
        <div className={styles.gridContainer}>
          {isSignupPage ? (
            <div className={styles.signupHeader}>
              <Link href="/" className={styles.signupLogo} aria-label="Torna alla home page del Movimento Rivoluzione Fiscale">
                <img src={logo} alt="Logo ufficiale Movimento Rivoluzione Fiscale" />
              </Link>
              {!isLogged && <Button className={cn(styles.buttonGreen, styles.signupButton)} href="/iscriviti/">Iscriviti</Button>}
              <Link className={styles.signupDocuments} href="/documenti/">DOCUMENTI</Link>
            </div>
          ) : <Grid container alignItems="center">
            <Grid item xs={disabled ? 6 : 4}>
              <Grid container alignItems="center">
                <Link
                  href="/"
                  aria-label="Torna alla home page del Movimento Rivoluzione Fiscale"
                  style={{ display: 'block', width: '420px', maxWidth: '100%' }}
                >
                  <img
                    src={logo}
                    alt={'Logo ufficiale Movimento Rivoluzione Fiscale'}
                    className={banner ? styles.logoBanner : styles.logo}
                    style={{
                      height: 'auto',
                      width: '100%',
                      marginRight: 0,
                      maxWidth: '100%',
                      objectFit: 'contain',
                      position: 'static',
                      display: 'block',
                    }}
                  />
                </Link>
              </Grid>
            </Grid>
            {!disabled && (
              <Grid item xs={4}>
                <Button className={styles.buttonDonation}>DONA AL MRF</Button>
              </Grid>
            )}
            <Grid
              item
              xs={disabled ? 6 : 4}
              container
              justify="flex-end"
              alignItems={'baseline'}
            >
              {
                !isLogged && (<Button
                  classes={{
                    root: styles.buttonGreen,
                  }}
                  className={styles.iscrivitHeader}
                  href='/iscriviti/'
                >
                  Iscriviti
                </Button>)
              }
              <Link
                className={styles.link}
                variant="subtitle1"
                href={'/documenti/'}
              >
                DOCUMENTI
              </Link>
              {!disabled && (
                <Link className={styles.link} variant="subtitle1">
                  CONTATTI
                </Link>
              )}
              {!disabled && (
                <Link className={styles.link} variant="subtitle1">
                  <img
                    alt="search"
                    src={search}
                    className={styles.searchIcon}
                  />
                  CERCA
                </Link>
              )}
            </Grid>
          </Grid>}
        </div>
      </div>
      {banner && (
        <div className={styles.headerContent}>
          <div className={styles.gridContainer}>
            <div className={styles.heroContent}>
              <div className={styles.heroCopy}>
                <Typography variant="h1" className={styles.title}>
                  {headlineLines ? <>{headlineLines[0]}<br />{headlineLines[1]}</> : banner.titolo}
                </Typography>
                <Typography variant="h2" className={styles.description}>
                  {banner.descrizione.descrizione}
                </Typography>
              </div>
              <div className={cn(styles.heroActions, isLogged && styles.heroActionsLogged)} aria-label="Accesso e canali MRF">
                {!isLogged && <Button className={cn(styles.heroAction, styles.heroAccess)} onClick={handleShowLoginDialog}>
                  Accesso iscritti
                </Button>}
                {!isLogged && <Button className={cn(styles.heroAction, styles.heroSignup)} href="/iscriviti/">
                  Iscriviti
                </Button>}
                <Button className={cn(styles.heroAction, styles.heroLinkedin)} target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/movimentorivoluzionefiscale/">
                  <LinkedInIcon className={styles.heroLinkedinIcon} aria-hidden="true" />
                  <span>Seguici su LinkedIn</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.headerNavigation}>
        <div className={styles.buttonsContainer}>
          <div className={styles.gridContainer}>
            <nav className={styles.sectionNavigation} aria-label="Sezioni del sito MRF">
              {sections.map((section) => (
                <div key={`section-${section.label}`} className={styles.buttonContainer}>
                  <Button
                    className={cn(
                      styles.buttonSection,
                      section.isSelected && styles.buttonSectionSelected,
                      section.subMenu && styles.buttonWithMenu
                    )}
                    href={section.href}
                  >
                    {section.label}
                  </Button>
                  {section.subMenu ? (
                    <Fragment>
                      <ButtonBase
                        className={styles.sectionMenuToggle}
                        aria-label="Apri le altre sezioni di politica"
                        aria-haspopup="true"
                        aria-expanded={open}
                        onClick={handleClick}
                      >
                        <ExpandMoreIcon />
                      </ButtonBase>
                      <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        classes={{
                          paper: styles.popOverContainer,
                        }}
                      >
                        {section.subMenu.map((subMenuElement) => (
                          <div
                            key={`section-${subMenuElement.label}`}
                            className={styles.subMenuButtonContainer}
                          >
                            <Button
                              variant={'body1'}
                              className={styles.subMenuButton}
                              href={subMenuElement.href}
                            >
                              {subMenuElement.label}
                            </Button>
                          </div>
                        ))}
                      </Popover>
                    </Fragment>
                  ) : null}
                </div>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </div>
  )
}

